import { RVRoutingPage } from "@regal-voice/ui";
import { initLooker } from "Services/Looker/LookerService";

import { ConvoIntelSubNav } from "./Components/ConvoIntelSubNav/ConvoIntelSubNav";

initLooker();
export default function ConvoIntelRoutingPage(): JSX.Element {
    return <RVRoutingPage nav={<ConvoIntelSubNav />} />;
}
